"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./index.css");
var utils_1 = require("./utils");
// Default delay for animation for smooth experience
var DEFAULT_ANIMATION_DELAY = 250;
var BottomSheetView = function (props) {
    var bottom = props.bottom, children = props.children, isExpandable = props.isExpandable, customHeight = props.customHeight, onTouchStart = props.onTouchStart, onMove = props.onMove, onTouchEnd = props.onTouchEnd, onScroll = props.onScroll, backdropClassName = props.backdropClassName, backdropStyle = props.backdropStyle, containerClassName = props.containerClassName, containerStyle = props.containerStyle, isFullscreen = props.isFullscreen, animationName = props.animationName, closeBottomSheet = props.closeBottomSheet;
    var style = {
        bottom: bottom + "px",
        height: !isExpandable
            ? customHeight
                ? customHeight + "px"
                : "auto"
            : "",
        overflowY: isFullscreen || !isExpandable ? "scroll" : "hidden",
        overflowX: "hidden",
    };
    var preventDefaultAll = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    return (react_1.default.createElement("div", { className: "bottom-sheet__wrapper " + (backdropClassName ? backdropClassName : null), onClick: closeBottomSheet, onTouchMove: preventDefaultAll, style: backdropStyle ? backdropStyle : null },
        react_1.default.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, style: containerStyle ? __assign(__assign({}, style), containerStyle) : style, onScroll: onScroll, className: "bottom-sheet__container " + (containerClassName ? containerClassName : null) + " " + animationName, onTouchMove: onMove, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd }, react_1.default.cloneElement(children, { closeBottomSheet: closeBottomSheet }))));
};
var INITIAL_BOTTOM_VALUE = -9000;
var BottomSheet = function (props) {
    var children = props.children, isExpandable = props.isExpandable, customHeight = props.customHeight, onClose = props.onClose, backdropClassName = props.backdropClassName, backdropStyle = props.backdropStyle, containerClassName = props.containerClassName, containerStyle = props.containerStyle, animationDelay = props.animationDelay;
    // Get screen height and listen to resizes
    var heightHook = utils_1.hookHeight();
    var _a = react_1.useState(0), height = _a[0], setHeight = _a[1];
    // Save isScrolled value to prevent moving container while scrolling content
    var _b = react_1.useState(false), isScrolled = _b[0], setScrolled = _b[1];
    var _c = react_1.useState(false), isFullscreen = _c[0], setFullscreen = _c[1];
    // Store initial Y touch for calculations
    var _d = react_1.useState(0), initTouchY = _d[0], setInitTouchY = _d[1];
    // Initial value from which will BottomSheet raise
    var _e = react_1.useState(INITIAL_BOTTOM_VALUE), bottom = _e[0], setBottom = _e[1];
    // Store current bottom value
    var _f = react_1.useState(0), bottomBase = _f[0], setBottomBase = _f[1];
    // Switch between different css animations
    var _g = react_1.useState(""), animationName = _g[0], setAnimationName = _g[1];
    var animationDelayValue = animationDelay
        ? animationDelay
        : DEFAULT_ANIMATION_DELAY;
    /**
     * Handle initial opening animation
     */
    react_1.useEffect(function () {
        // Set initial height
        setHeight(heightHook);
        var bottomInitial;
        // Trigger opening animation
        if (!isExpandable) {
            // Set base bottom value to show whole container
            bottomInitial = 0;
            setAnimationName('bottom-sheet__animate-open-modal');
        }
        else {
            // Show only half of the container
            bottomInitial = (heightHook / 2) * -1;
            setAnimationName('bottom-sheet__animate-open');
        }
        // Store initial values for further calculations
        setBottom(bottomInitial);
        setBottomBase(bottomInitial);
    }, []);
    /**
     * Prevent bottom sheet movement when children is scrolled or set initial
     * touch point on Y axis
     * @param e
     */
    var onTouchStart = function (e) {
        // Prevent unwanted movement when children is scrolled
        if (isScrolled) {
            return;
        }
        // Set initial touch point for horizontal movement
        var touchEventY = e.nativeEvent.touches[0].clientY;
        setInitTouchY(touchEventY);
    };
    /**
     * Close bottom sheet or revert to basic position
     */
    var onTouchEnd = function () {
        // Prevent unwanted movement
        // when children is scrolled or for clicks
        if (isScrolled || bottom === bottomBase) {
            return;
        }
        if (!isExpandable) {
            var TRIGGER_NON_EXPANDABLE_RESET = (height / 3 / 10) * 3 * -1;
            if (bottom > 0) {
                // Moving up is disabled
                return;
            }
            else if (bottom > TRIGGER_NON_EXPANDABLE_RESET) {
                // Trigger reset to basic position
                setAnimationName("bottom-sheet__animate-reset-modal");
                setTimeout(function () {
                    setBottom(0);
                    setBottomBase(0);
                    setAnimationName("");
                }, animationDelayValue);
            }
            else {
                // Close bottom sheet
                setAnimationName("bottom-sheet__animate-close");
                setTimeout(function () {
                    setBottom(-height);
                    setBottomBase(-height);
                    closeBottomSheet();
                }, animationDelayValue);
            }
        }
        if (isExpandable) {
            var TRIGGER_EXPANDABLE_FULL_HEIGHT = bottom > (height / 2) * -1 && bottomBase !== 0;
            var TRIGGER_EXPANDABLE_RESET_TO_MIDDLE = bottom > (height / 10) * 7 * -1;
            var TRIGGER_EXPANDABLE_RESET_TO_FULL = bottom > (height / 3) * 2 * -1 && bottomBase !== (height / 2) * -1;
            // Expand bottom sheet to full height
            if (TRIGGER_EXPANDABLE_FULL_HEIGHT) {
                setAnimationName("bottom-sheet__animate-open-full");
                setTimeout(function () {
                    setBottom(0);
                    setAnimationName("");
                    setFullscreen(true);
                    setBottomBase(0);
                }, animationDelayValue);
            }
            else if (TRIGGER_EXPANDABLE_RESET_TO_MIDDLE || TRIGGER_EXPANDABLE_RESET_TO_FULL) {
                // Reset to middle
                setAnimationName("bottom-sheet__animate-reset");
                setTimeout(function () {
                    setBottom((height / 2) * -1);
                    setBottomBase((height / 2) * -1);
                    setAnimationName("");
                    setFullscreen(false);
                }, animationDelayValue);
            }
            else {
                // Close bottom sheet
                setFullscreen(false);
                closeBottomSheet();
            }
        }
    };
    var closeBottomSheet = function (e) {
        if (e === void 0) { e = undefined; }
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setAnimationName("bottom-sheet__animate-close");
        setTimeout(function () {
            setBottom(-height);
            setBottomBase(-height);
            if (onClose) {
                onClose();
            }
        }, animationDelayValue);
    };
    var setNewBottom = function (value) {
        setBottom(value);
    };
    /**
     * Handle touch moves in container
     * @param e
     */
    var onMove = function (e) {
        if (isScrolled) {
            return;
        }
        e.preventDefault();
        // Adjust touch coordinates for natural movement
        var touchEventY = e.nativeEvent.touches[0].clientY;
        var differenceInTouch = initTouchY - touchEventY;
        // Set new bottom value
        var newBottomValue = bottomBase + differenceInTouch;
        // Prevent scrolling over bottom 0
        if (newBottomValue > 0) {
            return;
        }
        // Need different rules for up/down handling
        if (isFullscreen) {
            if (newBottomValue > bottomBase) {
                return;
            }
        }
        if (newBottomValue > bottom) {
            // Handle open to fullscreen
            if (!isExpandable) {
                return;
            }
        }
        setNewBottom(newBottomValue);
    };
    /**
     * Handle scrolling
     * @param e
     */
    var onScroll = function (e) {
        if (e.target.scrollTop > 0) {
            setScrolled(true);
            setFullscreen(true);
        }
        else {
            setScrolled(false);
        }
    };
    return (react_1.default.createElement(BottomSheetView, { children: children, animationName: animationName, bottom: bottom, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, onMove: onMove, onClose: onClose, isFullscreen: isFullscreen, onScroll: onScroll, closeBottomSheet: closeBottomSheet, isExpandable: isExpandable, customHeight: customHeight, backdropClassName: backdropClassName, backdropStyle: backdropStyle, containerClassName: containerClassName, containerStyle: containerStyle }));
};
exports.default = BottomSheet;
